/**
 * This dynamic import is the "Async Boundary".
 * It allows Webpack to negotiate shared versions of React, Okta, and
 * Cisco shared libraries before the application code actually runs.
 */
import('./bootstrap');

export {};
